import { BREAKPOINTS as f } from "../constants/breakpoints.js";
import { useRef as o, useEffect as n } from "react";
import { useMatchMedia as i } from "./useMatchMedia.js";
function p(r, e) {
  const u = i(typeof r == "string" ? f[r] : r), t = o(!1);
  return n(() => {
    t.current = !0;
  }, []), t.current ? u : e === void 0 ? !1 : e;
}
export {
  p as useMediaQuery
};
